import { render, staticRenderFns } from "./Genders.vue?vue&type=template&id=ebba3e48&scoped=true&"
import script from "./Genders.vue?vue&type=script&lang=js&"
export * from "./Genders.vue?vue&type=script&lang=js&"
import style0 from "./Genders.vue?vue&type=style&index=0&id=ebba3e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebba3e48",
  null
  
)

export default component.exports